import { IInteresseomraade } from "../interfaces/accounts";
import {
  FirmaStamdata,
  OpretStamdataaendringBasisDto,
  OpretStamdataaendringBasisResponse,
  OpretStamdataaendringInteresseDto,
  OpretStamdataaendringInteresseResponse,
  PersonStamdata,
  Titel,
} from "../interfaces/stamdata";
import { erProfilKlar } from "../lib/stamdataProfil";
import { get, post } from "./util";

/**
 * Henter medlemmets stamdata, eller `null` hvis profilen ikke er oprettet i portalen endnu.
 *
 * `null` betyder én ting og kun én: serveren svarede, og der var ingen profil. Transportfejl kaster
 * som hidtil, så de to tilstande kan ikke forveksles af kaldere.
 *
 * Normaliseringen ligger her, fordi det er portalens eneste kald til `HentPerson`. Serveren svarer
 * 200 med et tomt `PersonModel` for et medlem uden Person-række (ADV-272), og det svar bestod
 * portalens truthy-guards hele vejen ned: tomme felter blev vist frem som en indlæst profil, og
 * `Guid.Empty` blev sendt tilbage som `personId` (ADV-288). Ved at oversætte tilstanden til `null`
 * netop her bliver de guards, der allerede står i komponenterne, rigtige — de var skrevet, som om en
 * manglende profil var `null`, de blev blot aldrig født med det.
 */
export async function getStamdataPerson(
  id: string,
): Promise<PersonStamdata | null> {
  const person = await get<PersonStamdata>({
    query: `Stamdata/HentPerson/?id=${id}`,
  });
  return erProfilKlar(person) ? person : null;
}
export async function getStamdataFirma(id: string) {
  return get<FirmaStamdata>({
    query: `Stamdata/HentFirma/?id=${id}`,
  });
}

export async function getStamdataTitler() {
  return get<Titel[]>({
    query: "Stamdata/HentTitler",
  });
}

export async function getInteresser() {
  return get<IInteresseomraade[]>({
    query: "Stamdata/HentInteresser",
  });
}

export async function opretStamdataaendringBasis(
  dto: OpretStamdataaendringBasisDto,
) {
  return post<OpretStamdataaendringBasisResponse>({
    query: "Stamdata/OpretStamdataaendringBasis",
    body: dto,
  });
}

export async function opretStamdataaendringInteresse(
  dto: OpretStamdataaendringInteresseDto,
) {
  return post<OpretStamdataaendringInteresseResponse>({
    query: "Stamdata/OpretStamdataaendringInteresse",
    body: dto,
  });
}
